<template>
  <auth-frame :title="tr('Support Login')">
    <form class="flex flex-col gap-4" novalidate @submit="$event => onFormSubmit($event)">
      <div class="flex flex-col gap-1.5">
        <ui-label for="support-email">{{ tr('E-mail') }}</ui-label>
        <ui-input
          id="support-email"
          v-model="email"
          type="email"
          autocomplete="username"
          :placeholder="tr('you@gmail.com')"
          :disabled="isLoading"
        />
      </div>
      <div class="flex flex-col gap-1.5">
        <ui-label for="support-password">{{ tr('Password') }}</ui-label>
        <password-field
          id="support-password"
          v-model="password"
          :placeholder="tr('Enter at least 8 characters...')"
          :disabled="isLoading"
        />
      </div>
      <div class="flex flex-col gap-1.5">
        <ui-label>{{ tr('Two-factor authentication code') }}</ui-label>
        <auth-code-input
          ref="authCodeInput"
          v-model="code"
          :disabled="isLoading"
          @enter="() => onFormSubmit()"
        />
      </div>

      <ui-button
        type="submit"
        size="lg"
        class="mt-2 w-full"
        :disabled="isLoading"
      >
        <loader-circle-icon v-if="isLoading" class="animate-spin" />
        {{ tr('Login') }}
      </ui-button>
    </form>
  </auth-frame>
</template>

<script>
import { LoaderCircle } from '@lucide/vue';

import { UnauthorizedError } from '@/errors';
import AuthCodeInput from '@/ui/components/AuthCodeInput.vue';
import AuthFrame from '@/ui/components/AuthFrame.vue';
import PasswordField from '@/ui/components/PasswordField.vue';
import { isValidEmail } from '@/utils/validators';

export default {
  name: 'SupportLoginView',
  components: {
    AuthCodeInput,
    AuthFrame,
    LoaderCircleIcon: LoaderCircle,
    PasswordField,
  },
  data() {
    return {
      isLoading: false,
      email: '',
      password: '',
      code: '',
    };
  },
  methods: {
    resetForm() {
      this.email = '';
      this.password = '';
      this.code = '';
    },
    onFormSubmit($event) {
      if ($event) {
        $event.preventDefault();
      }

      if (!this.validate()) {
        return;
      }

      this.isLoading = true;
      this.$store
        .dispatch('support/login', {
          email: this.email,
          password: this.password,
          code: this.code,
        })
        .then(resp => {
          if (window.PasswordCredential) {
            const passwordCredential = new window.PasswordCredential({ id: this.email, password: this.password });
            navigator.credentials.store(passwordCredential);
          }

          this.$router.replace({ path: '/support/masquerade' });
          this.$nextTick(() => this.resetForm());

          return resp;
        })
        .catch(err => {
          if (err instanceof UnauthorizedError) {
            this.$toast.error(this.tr('Invalid login information.'));
          }
          else {
            this.error(err);
          }
        })
        .finally(() => this.isLoading = false);
    },
    validate() {
      this.$toast.clear();

      if (!this.email || !isValidEmail(this.email)) {
        this.$toast.error(this.tr('Invalid email address.'));
        return false;
      }
      else if (!this.password) {
        this.$toast.error(this.tr('Password is required.'));
        return false;
      }
      else if (this.code.length !== 6) {
        this.$toast.error(this.tr('Two-factor authentication code is required.'));
        return false;
      }

      return true;
    },
  },
};
</script>
